import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
  WorksheetsResultsMessagesSection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../Layout';
import ids from '../QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from './Sections';

const qestIds = [ids.specificGravityCoarse.AASHTO_T_85.rev2014, ids.specificGravityCoarse.ASTM_C_127.rev2015];

let SpecificGravityCoarseWorksheet = () => (
  <>
    <PageSection heading="Preparation">
      <PreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <MeasurementsSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <WorksheetsResultsMessagesSection />
      <ResultsSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

SpecificGravityCoarseWorksheet.qestIds = qestIds;

export default SpecificGravityCoarseWorksheet;
export { SpecificGravityCoarseWorksheet };
